import { APP_KEY } from "./Consts";
import { decryptData } from "./Utils";

/** Read persisted admin access token without importing AuthController (avoids circular deps). */
export const getPersistedAccessToken = () => {
  try {
    const raw = localStorage?.getItem(APP_KEY);
    if (!raw) return null;
    const session = decryptData(raw, import.meta.env.VITE_SECRET_KEY);
    return session?.accessToken || null;
  } catch {
    return null;
  }
};

export const clearPersistedSession = () => {
  localStorage?.removeItem(APP_KEY);
};
